/* =========================================================
   NVQ VOORSPELLENDE ZOEKFUNCTIE

   Vervangt de zoeksuggesties van het basisthema. Die bouwde de
   kaartjes zelf in JavaScript en liet daarbij prijs, korting,
   sterren en snelkoop weg.

   Deze versie haalt sections/nvq-predictive-search.liquid op via de
   zoeksuggestie-API. Daardoor is een kaartje in het zoekvenster
   precies hetzelfde kaartje als op een collectiepagina.
   ========================================================= */

(function () {
  'use strict';

  if (window.NvqPredictiveSearch) return;

  var SECTION_ID = 'nvq-predictive-search';
  var DEBOUNCE_MS = 250;
  /* Vanaf de eerste letter al suggesties. Shopify vindt bij elke losse
     letter ruim voldoende producten, dus er valt meteen wat te kiezen. */
  var MIN_CHARS = 1;
  var LIMIT = 6;

  var input = null;
  var wrapper = null;
  var results = null;
  var status = null;

  var timer = null;
  var controller = null;
  var lastTerm = '';

  function resourceTypes() {
    /* Zelfde bronsoorten als de gewone zoekpagina, maar zonder types
       die de suggestie-API niet ondersteunt. */
    var raw = (window.theme && theme.settings && theme.settings.predictiveSearchType) || 'product';
    var allowed = ['product', 'collection', 'page', 'article'];
    var out = [];
    String(raw).split(',').forEach(function (t) {
      t = t.trim();
      if (allowed.indexOf(t) !== -1 && out.indexOf(t) === -1) out.push(t);
    });
    return out.length ? out.join(',') : 'product';
  }

  function rootUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function open() {
    if (!wrapper) return;
    wrapper.classList.remove('hide');
    wrapper.setAttribute('data-nvq-ps-open', 'true');
    if (input) input.setAttribute('aria-expanded', 'true');
  }

  function close() {
    if (!wrapper) return;
    wrapper.classList.add('hide');
    wrapper.removeAttribute('data-nvq-ps-open');
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  function reset() {
    lastTerm = '';
    if (results) results.innerHTML = '';
    close();
  }

  function setBusy(busy) {
    if (!wrapper) return;
    wrapper.setAttribute('data-nvq-ps-loading', busy ? 'true' : 'false');
  }

  /* Judge.me levert de sterren als kant-en-klare HTML mee in het kaartje,
     maar houdt ze verborgen tot zijn eigen script ze vrijgeeft. Voor
     onderdelen die later binnenkomen geven we dat zetje zelf. */
  function refreshBadges() {
    try {
      if (!window.jdgm) return;
      if (typeof window.jdgm.updateBadges === 'function') window.jdgm.updateBadges();
      else if (typeof window.jdgm.batchRenderBadges === 'function') window.jdgm.batchRenderBadges();
    } catch (e) {
      /* Reviews zijn een extraatje: als de app hapert mag het zoeken gewoon doorgaan. */
    }
  }

  function announce(count) {
    if (!status) return;
    status.textContent = count > 0 ? count + '' : '';
  }

  function search(term) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url =
      rootUrl() +
      'search/suggest?q=' + encodeURIComponent(term) +
      '&section_id=' + SECTION_ID +
      '&resources[type]=' + encodeURIComponent(resourceTypes()) +
      '&resources[limit]=' + LIMIT +
      /* Zonder `limit_scope=each` geldt de limiet over álle soorten samen:
         vraag je ook categorieën en pagina's op, dan hou je maar 3 producten
         over. Met `each` telt de limiet per soort. */
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';

    setBusy(true);

    fetch(url, { signal: controller.signal, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('suggest ' + response.status);
        return response.text();
      })
      .then(function (html) {
        /* Antwoord van een oudere toetsaanslag negeren. */
        if (term !== lastTerm) return;

        var holder = document.createElement('div');
        holder.innerHTML = html;
        /* De Section Rendering API geeft de sectie in een wikkel terug. */
        var section = holder.querySelector('.shopify-section') || holder;

        results.innerHTML = section.innerHTML;
        setBusy(false);
        open();
        refreshBadges();
        announce(results.querySelectorAll('[data-nvq-product-card]').length);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        setBusy(false);
        reset();
      });
  }

  function onInput() {
    var term = (input.value || '').trim();

    clearTimeout(timer);

    if (term.length < MIN_CHARS) {
      if (controller) controller.abort();
      reset();
      return;
    }

    if (term === lastTerm) return;
    lastTerm = term;

    timer = setTimeout(function () {
      search(term);
    }, DEBOUNCE_MS);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      closeAll();
      return;
    }
    /* Enter laat gewoon het formulier naar de volledige zoekpagina gaan. */
  }

  /* Sluit niet alleen de suggesties, maar de hele zoekbalk. Het basisthema
     doet dat ook, maar alleen voor kliks buiten zijn eigen zoekvak — en het
     suggestievenster valt daarbinnen. Wie op de lege ruimte van dat venster
     klikt, verwacht dat alles dichtgaat. Daarom regelen we het hier zelf. */
  function closeAll() {
    reset();

    var container = document.querySelector('.site-header__search-container');
    var closeBtn = document.getElementById('SearchClose');

    /* De sluitknop van het thema hergebruiken: die zet ook de focusval,
       de schuifvergrendeling en de klassen op het document terug. */
    if (container && closeBtn && container.classList.contains('is-active')) {
      closeBtn.click();
    }
  }

  function searchIsOpen() {
    var container = document.querySelector('.site-header__search-container');
    var paneelOpen = wrapper && !wrapper.classList.contains('hide');
    return paneelOpen || (container && container.classList.contains('is-active'));
  }

  function onDocumentClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!searchIsOpen()) return;

    /* De knop die het zoeken opent, en de sluitknop: die doen hun eigen werk. */
    if (target.closest('.js-search-header')) return;
    if (target.closest('#SearchClose')) {
      reset();
      return;
    }

    /* In het zoekvak zelf typen of klikken mag gewoon. */
    if (target.closest('.site-header__search-form')) return;

    /* Een link of knop in de suggesties laten we zijn gang gaan; die
       navigeert of opent de snelkoop. Alle overige ruimte in het venster
       telt als "ergens anders" en sluit dus alles. */
    if (target.closest('#NvqPredictiveWrapper') && target.closest('a, button')) return;

    closeAll();
  }

  function init() {
    wrapper = document.getElementById('NvqPredictiveWrapper');
    if (!wrapper) return;

    results = wrapper.querySelector('[data-nvq-ps-results]');
    status = wrapper.querySelector('[data-nvq-ps-status]');
    input = document.querySelector('.site-header__search-input');
    if (!results || !input) return;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', 'NvqPredictiveWrapper');
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onKeydown);
    document.addEventListener('click', onDocumentClick);

    /* De sluitknop van de zoekbalk ruimt ook de suggesties op. */
    var closeBtn = document.getElementById('SearchClose');
    if (closeBtn) closeBtn.addEventListener('click', reset);
  }

  window.NvqPredictiveSearch = { reset: reset };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
